import { NEUTRAL_TONE, type Tone } from "@kensio/pinyinjs";

/**
 * What class colours a syllable of a given tone.
 *
 * Here rather than in `src/tools/` because two surfaces now paint pinyin by
 * tone and only one of them is a page on this site. The conversion tools read
 * `.tone-1` out of the compiled theme, and the extension's panel declares the
 * same five class names in its own shadow root, so the numbering has to be one
 * answer rather than two that agree by hand. `src/tools/tone-colour.ts` is the
 * rest of what a page needs, the clipboard colours above all, and stays there.
 *
 * The package numbers the neutral tone 5 and this site numbers it 0, which is
 * the whole of the translation. A syllable with no tone written at all, which
 * is a different thing from a neutral one, gets no class and stays the colour
 * of the text around it.
 */
export function toneClass(tone: Tone | undefined): string | undefined {
  if (tone === undefined) {
    return undefined;
  }

  return tone === NEUTRAL_TONE ? "tone-0" : `tone-${String(tone)}`;
}
